import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { IContent } from 'app/store/models/content.model';
import { ContentService } from 'app/store/services/content.service';
import { SessionService } from '../../store/services/session.service';
import { IUserSessionData } from '../../store/models/user.model';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-content-preview',
  templateUrl: './content-preview.component.html',
  styleUrls: ['./content-preview.component.scss'],
})
export class ContentPreviewComponent implements OnInit, OnDestroy {
  contentId: number;
  content: IContent;
  sessionData: IUserSessionData;
  contentGroupName: any;

  private readonly destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private activatedRoute: ActivatedRoute,
    private contentService: ContentService,
    private readonly sessionService: SessionService,
    private readonly domSanitizer: DomSanitizer,
  ) {
  }

  ngOnInit() {
    this.sessionService
      .onReady()
      .pipe(takeUntil(this.destroy$))
      .subscribe(sessionData => {
        this.sessionData = sessionData;
        this.contentId = this.activatedRoute.snapshot.params.id;
        this.contentGroupName = this.activatedRoute.snapshot.params.group_name;

        this.contentService
          .getContentInfo(this.contentId)
          .subscribe((content: IContent) => (this.content = content));
      });
  }

  getTemplateName() {
    return (
      this.content.content_template.charAt(0).toUpperCase() +
      this.content.content_template.split('_').join(' ').substr(1)
    );
  }

  getContentSign(): string {
    return this.content.content_sign
      .replace('<strong>', '<b>')
      .replace('</strong>', '</b>')
      .replace(new RegExp('\r\n', 'g'), '</br>');
  }

  getBackButtonRoute() {
    return [
      `/contents/${this.content.content_group_id}/content`,
      {
        group_name: this.content.content_group,
      },
    ];
  }

  getEditButtonRoute() {
    return [`/contents/${this.content.content_id}/edit`, {
      from: 'preview',
      group_name: this.content.content_group,
    }];
  }

  ngOnDestroy(): void {
    this.destroy$.next(false);
  }

  sanitize(content: string): SafeHtml {
    if (!content) {
      return '';
    }
    return this.domSanitizer.bypassSecurityTrustHtml(content);
  }
}
